import { makeLazy } from "lib/make-lazy"

export const FacilityCompleteCard = makeLazy(
    () => import("./inner-facility-complete-card"),
    "InnerFacilityCompleteCard"
)
